// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound-module--not-found--FOWoR","notFound__content":"NotFound-module--not-found__content--3zAg2","white":"NotFound-module--white--3MuFH"};